
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-insurance/tax",
      function () {
        return require("private-next-pages/health-insurance/tax/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-insurance/tax"])
      });
    }
  